// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"batch-entry-fund-totals__container___2I9Vr","item":"batch-entry-fund-totals__item___29QPo","name":"batch-entry-fund-totals__name___9-pdT","code":"batch-entry-fund-totals__code___2bmhJ","notes":"batch-entry-fund-totals__notes___2dmI4","total":"batch-entry-fund-totals__total___xj2Lx"};
    if(module.hot) {
      // 1769485160711
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  